import React from 'react';
import Button from 'react-bootstrap/Button';
import OverlayTrigger, { OverlayTriggerProps } from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import InfoIcon from '../../svgs/info.svg';

interface InfoTooltipProps {
    id: string;
    label?: string;
    placement: OverlayTriggerProps['placement'];
    tooltip: string;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({
    children = <InfoIcon className="align-top size-2 text-secondary" />,
    id,
    label = 'More info',
    placement,
    tooltip,
}) => {
    return (
        <OverlayTrigger
            overlay={
                <Popover content id={id}>
                    {tooltip}
                </Popover>
            }
            placement={placement}
        >
            <Button aria-label={label} className="align-baseline border-0 p-0 text-decoration-none" variant="link">
                {children}
            </Button>
        </OverlayTrigger>
    );
};

export { InfoTooltip, InfoTooltipProps };
